import React from 'react';
import {useIntl} from 'react-intl';
import { Link } from 'react-router-dom';
import {TPartnerDetailsData} from '@marketplace/api';

type TProps = {
  data: TPartnerDetailsData,
  loading: boolean | undefined,
  loaded: boolean | undefined,
}

export function PartnerDetails(props: TProps) {
  const {formatMessage} = useIntl()

  return (
    <>
      {props.loading && <div>Loading ...</div>}
      {props.loaded && (
        <div className="partner-details-tab">
          <div className="partner-details-tab__top-block">
            <div className="img-block">
              {props.data.logo && props.data.logo !=="" && <img src={props.data.logo} alt="" />}
            </div>
            <div className="text-block">
              <div className="info-block">
               {formatMessage({id: 'app_gallery_company_name'})}
              </div>
              <div className="partner-info">
                {props.data.company_name}
              </div>
              <div className="info-block">
               {formatMessage({id: 'app_gallery_website'})}
              </div>
              <div className="partner-info">
                {props.data.website &&
                  <Link to={{ pathname: props.data.website}} target="_blank" rel="noopener noreferrer">
                    {props.data.website}
                  </Link>
                }
              </div>  
            </div>
          </div>
          <div className="partner-details-tab__country-block">
            <div className="inner-block">
              <div className="info-block">
               {formatMessage({id: 'app_gallery_country'})}
              </div>
              <div className="partner-info">
                {props.data.country}
              </div>
            </div>
            <div className="inner-block">
              <div className="info-block">
               {formatMessage({id: 'app_gallery_city'})}
              </div>
              <div className="partner-info">
                {props.data.city}
              </div>
            </div>
          </div>
          <div className="partner-details-tab__country-block">
            <div className="inner-block">
              <div className="info-block">
               {formatMessage({id: 'app_gallery_state'})}
              </div>
              <div className="partner-info">
                {props.data.state}
              </div>
            </div>
            <div className="inner-block">
              <div className="info-block">
               {formatMessage({id: 'app_gallery_post_code'})}
              </div>
              <div className="partner-info">
                {props.data.postal_code}
              </div>
            </div>
          </div>
          <div className="partner-details-tab__description-block">
            <div className="info-block">
              {formatMessage({id: 'app_gallery_description'})}
            </div>
            <div className="partner-info">
              {props.data.applications_description}
            </div>
          </div>
        </div>
      )}
    </>
  )
}